import React, {Component} from "react"
import PaperBlock from "../../ui/PaperBlock"
import { Button, Typography, Chip } from "@material-ui/core"
import AddCategoryIcon from '@material-ui/icons/AddCircle'

/**
 * chips - выбранные магазины. 
 * 
 * onAddShopButtonClick() - нажатие на кнопку добавить магазин.
 * onShopFilterChipDeleteClick(chip) 
 */

class ShopFilterPanel extends Component {
    
    constructor(props) {
        super(props)
    }

    render() {
        return <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>
            <div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Typography style = {{flex: "1 1 auto"}}>Фильтр по магазинам</Typography>
                <Button
                    onClick={e => {
                        if (typeof this.props.onAddShopButtonClick === "function") {
                            this.props.onAddShopButtonClick()
                        }
                    }}
                >
                    <div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <AddCategoryIcon />
                        Добавить
                    </div>
                </Button>
            </div>
            <div style = {{
                display: "flex",
                gap: "10px",
            }}>
                {
                    this.props.chips ? this.props.chips.map((chip, n) => {
                        return <Chip
                            key = {n}
                            label = {chip.name}
                            style = {{ cursor: "pointer" }}
                            variant = "outlined"
                            onDelete = {e => {
                                if (typeof this.props.onShopFilterChipDeleteClick === "function") {
                                    this.props.onShopFilterChipDeleteClick(chip)
                                }
                            }}
                        
                        />
                    }) : null
                }
            </div>
        </PaperBlock>
    }

}

export default ShopFilterPanel